import axios from "axios";
const qs = require("qs");
import * as store from "@/_store";
import alertifyjs from "alertifyjs";
class Service {
  constructor() {
    // let user_token = localStorage.getItem("user_token");
    let service = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        // "access-token": user_token,
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    service.interceptors.request.use(
      config => {
        if (store.store.getters.token) {
          // let each request carry token
          // ['X-Token'] is a custom headers key
          // please modify it according to the actual situation
          config.headers["access-token"] = store.store.getters.token;
        }
        return config;
      },
      error => {
        // eslint-disable-next-line no-console
        console.log(error); // for debug
        return Promise.reject(error);
      }
    );
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }

  handleSuccess(response) {
    return response;
  }

  handleError = error => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          // required session
          // error.message = "Please Login";
          // this.redirectTo(document, "/login");
          break;
        case 401:
          // session expired
          error.message = "Session expired";
          this.redirectTo(document, "/login");
          break;
        case 402:
          // session expired
          error.message = "Please verify email";
          // this.redirectTo(document, "/verify-email");
          break;
        case 403:
          //debugger;
          // session permission
          // eslint-disable-next-line no-console
          // console.log("SERVER : YOU NOT PERMISSION");
          // error.message = "Not a permission";
          // this.redirectTo(document, "/permission");
          // alertifyjs.error(error.response.data.message, {
          //   duration: 2000
          // });
          break;
        case 404:
          // this.redirectTo(document, '/404')
          break;
        default:
          //this.redirectTo(document, '/500')
          break;
      }
    }
    let status = error.response ? error.response.status : false;
    if (status) {
      alertifyjs.error(error.response.data.message, {
        duration: 2000
      });
      return Promise.reject(error.response.data);
    } else {
      alertifyjs.error(error.message, {
        duration: 2000
      });
      return Promise.reject(error);
    }
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

  get(path, params) {
    var self = this;
    return new Promise((resolve, reject) => {
      self.service
        .get(path, {
          params
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          if (error.response && error.response.status == 404) {
            resolve({
              status: 200,
              data: {
                message: "try again",
                status: false,
                data: []
              }
            });
          } else {
            reject(error);
          }
        });
    });
  }

  patch(path, payload) {
    var self = this;
    return new Promise((resolve, reject) => {
      self.service
        .request({
          method: "PATCH",
          url: path,
          responseType: "json",
          data: payload
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  post(path, payload) {
    var self = this;
    return new Promise((resolve, reject) => {
      self.service
        .request({
          method: "POST",
          url: path,
          responseType: "json",
          data: qs.stringify(payload)
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  postFormData(path, body) {
    var self = this;
    const formData = new FormData();
    Object.keys(body).forEach(key => {
      formData.append(key, body[key]);
    });

    return new Promise((resolve, reject) => {
      self.service
        .request({
          method: "POST",
          url: path,
          responseType: "json",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          data: formData
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

export default new Service();
